<template>
  <div class="content">
    <div class="main">
      <div class="title">
        <span class="titleLeft">问答栏：</span>
        <div class="titleRight">
          <img :src="$common.getResourceUrl('pcweb/logo.jpg')" />
          <span>小白教育-专注于线上教育优秀企业</span>
        </div>
      </div>
      <div class="mainContent">
        <div class="userBox">
          <div
            v-for="(user, u) in chatMessage"
            :key="u"
            :class="user.class === 'b' ? 'user' : 'my'"
          >
            <img
              v-if="user.class === 'a'"
              class="myIcon"
              :src="$common.getResourceUrl('pcweb/logo.jpg')"
            />
            <div :class="user.class === 'b' ? 'userText' : 'myText'">
              <span v-html="user.text"></span>
            </div>
            <img v-if="user.class === 'b'" class="myIcon" :src="pic" />
          </div>
        </div>
      </div>

      <div class="bottom">
        <div class="ipt" @keyup.enter="send()">
          <el-input
            v-model="input"
            maxlength="150"
            placeholder="请输入想问的问题..."
            show-word-limit
            type="textarea"
          />
          <el-button type="primary" @click="send">发送</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      input: '',
      value: '',
      type: 1,
      chatMessage: [
        {
          id: 1,
          class: 'a',
          text: `
          <h4 style='margin-bottom:5px'>嗨~ 这位同学，欢迎来到小白云课堂！</h4>
          <p>1. 咨询订单问题，请发送 1</p>
          <p>2. 售后问题，请发送 2</p>
          <p>3. 选课问题，请发送 3</p>
          <p>4. 人工客服，请发送 0</p>
          `,
        },
        {
          id: 2,
          class: 'b',
          text: '你们公司是做什么的',
        },
        {
          id: 3,
          class: 'a',
          text: '我们公司是做线上教育的',
        },
      ],
    }
  },
  watch: {},
  mounted() {
    this.scrollToBottom()
  },
  created() {
    this.pic = JSON.parse(localStorage.getItem('info')).headpic
  },
  updated() {
    this.scrollToBottom()
  },
  methods: {
    send() {
      console.log(this.input)
      if (this.input.trim() === '') {
        this.$message('不允许发送空内容！')
        return false
      } else {
        const data = {
          id: this.chatMessage.length + 1,
          class: 'b',
          text: this.input,
        }
        this.chatMessage.push(data)
        this.input = ''
      }
    },
    a() {
      console.log(123)
    },
    // 发送消息之后滚动条自动定位到底部
    scrollToBottom() {
      this.$nextTick(() => {
        var container = this.$el.querySelector('.mainContent')
        container.scrollTop = container.scrollHeight
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
}
ul {
  list-style: none;
}
.main {
  height: 100%;
  width: 100%;
  border-radius: 10px;
  padding: 0 12px;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    .titleLeft {
      font-weight: 700;
      font-size: 20px;
      margin-left: 10px;
    }
    .titleRight {
      display: flex;
      align-items: center;
      margin-right: 20px;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        border-radius: 8px;
      }
      span {
        font-size: 16px;
        color: #999;
      }
    }
  }
  .mainContent {
    height: 520px;
    background-color: #f5f5f5;
    border-radius: 20px;
    overflow-y: auto;
    padding: 20px;
    img {
      width: 45px;
      height: 45px;
      border-radius: 15px;
    }
    .my {
      display: flex;
      margin-bottom: 20px;
      .myText {
        max-width: 500px;
        background-color: #fff;
        margin-left: 10px;
        border-radius: 10px;
        padding: 10px;
        font-size: 14px;
        line-height: 24px;
      }
    }
    .user {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      margin-bottom: 20px;
      .userText {
        max-width: 500px;
        background-color: dodgerblue;
        margin-right: 10px;
        border-radius: 10px;
        padding: 10px;
        font-size: 14px;
        line-height: 24px;
        color: #fff;
      }
      img {
        border-radius: 50%;
      }
    }
  }
}
.wentitype {
  margin: 15px 0;
}
.ipt {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 20px;
  ::v-deep(.el-textarea__inner) {
    height: 100px;
    font-size: 15px;
    padding: 7px 10px 17px;
  }
  ::v-deep(.el-button) {
    margin-right: 120px;
    margin-left: 15px;
    height: 45px;
    width: 100px;
  }
}
</style>
